import type { en } from '../en';
import admin from './admin.json';
import assets from './assets.json';
import auth from './auth.json';
import common from './common.json';
import damages from './damages.json';
import errors from './errors.json';
import files from './files.json';
import finance from './finance.json';
import health from './health.json';
import inspections from './inspections.json';
import viewer from './viewer.json';

export const de = {
	admin,
	assets,
	auth,
	common,
	damages,
	errors,
	files,
	finance,
	health,
	inspections,
	viewer,
} satisfies Record<keyof typeof en, object>;
